import PageSpinner from 'components/PageSpinner/PageSpinner';
import SessionTimeoutWarning from 'components/SessionTimeoutWarning/SessionTimeoutWarning';
import { useAuthentication, useAuthorization } from 'hooks/useAuth';
import { useHistoryTracker } from 'hooks/useHistoryTracker';
import { useJsdWidget } from 'hooks/useJsdWidget';
import { useUpdateSentryUser } from 'hooks/useUpdateSentryUser';
import React, { Suspense, useEffect, useMemo } from 'react';
import { Route, Routes } from 'react-router-dom';
import routes from 'routes';
import SecureRoute from 'routing/SecureRoute';

const AppRoutes: React.FC = () => {
  const { logoutLocal } = useAuthorization();
  const { isLoading, error } = useAuthentication();

  useUpdateSentryUser();
  useHistoryTracker();
  useJsdWidget();

  useEffect(() => {
    if (error && !isLoading) {
      logoutLocal('error', error);
    }
  }, [error, isLoading, logoutLocal]);

  // without memoizing the routes jsx any state change causes a full re-render
  const routesJsx = useMemo(
    () =>
      Object.entries(routes).map(([key, { userAuthState, roles, component: Component, ...rest }]) => {
        const insecure = userAuthState == 'Not Authenticated';
        const El = insecure ? (
          <Suspense key={key} fallback={<PageSpinner />}>
            <Component {...rest} />
          </Suspense>
        ) : (
          <SecureRoute key={key} {...{ ...rest, userAuthState, roles, component: Component }} />
        );
        return <Route key={key} {...rest} element={El} />;
      }),
    [],
  );

  return isLoading || error ? (
    <PageSpinner />
  ) : (
    <>
      <Routes>{routesJsx}</Routes>
      <SessionTimeoutWarning />
    </>
  );
};

export default AppRoutes;
